export const Button = {
  // style object for base or default style
  baseStyle: {
    fontWeight: 'regular',
    borderRadius: '4px',
    width: 'fit-content',
    _focus: {
      boxShadow: 'none',
      outline: 'none',
    },
  },
  variants: {
    solid: {
      bg: 'blue.500',
      color: 'white',
      border: 'none',
      _hover: {
        bg: 'blue.700',
        _disabled: {
          bg: 'blue.500',
        },
      },
      _disabled: {
        bg: 'blue.500',
      },
      _active: {
        bg: 'blue.700',
      },
    },
    'solid-dest': {
      border: 'none',
      bg: 'red.500',
      color: 'white',
      _hover: {
        bg: 'red.700',
        _disabled: {
          bg: 'red.500',
        },
      },
      _disabled: {
        bg: 'red.500',
      },
      _active: {
        bg: 'red.700',
      },
    },
    outline: {
      bg: 'white',
      color: 'blue.500',
      border: '1px solid',
      borderColor: 'blue.400',
      _hover: {
        bg: 'blue.50',
        _disabled: {
          text: 'blue.400',
        },
      },
      _disabled: {
        bg: 'white',
        borderColor: 'blue.400',
        text: 'blue.400',
      },
      _active: {
        bg: 'blue.100',
        boxShadow: 'none',
      },
    },
    'outline-dest': {
      bg: 'white',
      color: 'red.500',
      border: '1px solid',
      borderColor: 'red.400',
      _hover: {
        bg: 'red.50',
        _disabled: {
          text: 'red.400',
        },
      },
      _disabled: {
        bg: 'white',
        borderColor: 'red.400',
        text: 'red.400',
      },
      _active: {
        bg: 'red.100',
        boxShadow: 'none',
      },
    },
    ghost: {
      color: 'blue.500',
      _hover: {
        bg: 'blue.50',
        _disabled: {
          text: 'blue.400',
        },
      },
      _disabled: {
        bg: 'white',
        text: 'blue.400',
      },
      _active: {
        bg: 'blue.100',
        boxShadow: 'none',
      },
    },
    'ghost-dest': {
      color: 'red.500',
      _hover: {
        bg: 'red.50',
        _disabled: {
          text: 'red.400',
        },
      },
      _disabled: {
        bg: 'white',
        text: 'red.400',
      },
      _active: {
        bg: 'red.100',
        boxShadow: 'none',
      },
    },
    link: {
      bg: 'none',
      color: 'blue.500',
      border: 'none',
      lineHeight: 'normal',
      padding: 0,
      height: 'auto',
      verticalAlign: 'baseline',
      _hover: {
        textDecoration: 'none',
        color: 'blue.900',
        _disabled: {
          text: 'blue.400',
        },
      },
      _disabled: {
        text: 'blue.400',
      },
      _active: {
        color: 'blue.700',
      },
    },
    'link-dest': {
      bg: 'none',
      color: 'red.500',
      border: 'none',
      lineHeight: 'normal',
      padding: 0,
      height: 'auto',
      verticalAlign: 'baseline',
      _hover: {
        textDecoration: 'none',
        color: 'red.900',
        _disabled: {
          text: 'red.400',
        },
      },
      _disabled: {
        text: 'red.400',
      },
      _active: {
        color: 'red.900',
      },
    },
    iconButton: {
      bg: 'none',
      color: 'blue.500',
      border: 'none',
      _hover: {
        textDecoration: 'none',
        color: 'blue.700',
        _disabled: {
          text: 'blue.400',
        },
      },
      _disabled: {
        text: 'blue.400',
      },
      _active: {
        color: 'blue.700',
      },
    },
    'solid-ai': {
      bg: 'purple.500',
      color: 'white',
      border: 'none',
      _hover: {
        bg: 'purple.700',
        _disabled: {
          bg: 'purple.500',
        },
      },
      _disabled: {
        bg: 'purple.500',
      },
      _active: {
        bg: 'purple.700',
      },
    },
    'outline-ai': {
      bg: 'white',
      color: 'purple.500',
      border: '1px solid',
      borderColor: 'purple.400',
      _hover: {
        bg: 'purple.50',
        _disabled: {
          text: 'purple.400',
        },
      },
      _disabled: {
        bg: 'white',
        borderColor: 'purple.400',
        text: 'purple.400',
      },
      _active: {
        bg: 'purple.100',
        boxShadow: 'none',
      },
    },
    'ghost-ai': {
      color: 'purple.500',
      _hover: {
        bg: 'purple.50',
        _disabled: {
          text: 'purple.400',
        },
      },
      _disabled: {
        bg: 'white',
        text: 'purple.400',
      },
      _active: {
        bg: 'purple.100',
        boxShadow: 'none',
      },
    },
    'link-ai': {
      bg: 'none',
      color: 'purple.500',
      border: 'none',
      lineHeight: 'normal',
      padding: 0,
      height: 'auto',
      verticalAlign: 'baseline',
      _hover: {
        textDecoration: 'none',
        color: 'purple.900',
        _disabled: {
          text: 'purple.400',
        },
      },
      _disabled: {
        text: 'purple.400',
      },
      _active: {
        color: 'purple.700',
      },
    },
  },
  defaultProps: {
    size: 'sm',
    variant: 'solid',
    colorScheme: 'blue',
  },
};
